import Bloc from './Bloc.js';
import Types from './Types.js';

export default class FilterType extends Bloc {

	constructor (src, ctx) {

		super("filtertype", src, ctx);
		this.f = (src, ins) => {
			const type = ins[0]?.type || ins[0];
			return [card => card.type === type];
		};
		this.types = [Types.value];
	}
}
